// import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';
import { JobNames } from '../framework.core/JobNames';
import { formatDateTime,formatDate, now } from '../dateUtils';
import { Decimalformat } from '../components/common/commonExportFormat';
import moment from 'moment';
import fastStorage from '../fastStorage';
import {storageKeyMap} from '../hooks/useSetEditedId';


function toColumnName(num) {
  for (var ret = '', a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
    ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
  }
  return ret;
}

export function exportDomTableIntoExcel(domId, title, userId, jobName, listview, appcontext, searchData, listurl = "") {
  const oiQuotation = 'ifms-list-data-/common/joblistview/oiQuotation/oceanImport?parentOp=oceanImport';
  const oeQuotation = 'ifms-list-data-/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport';
  const aiQuotation = 'ifms-list-data-/common/joblistview/aiQuotation/airImport?parentOp=airImport';
  const aeQuotation = 'ifms-list-data-/common/joblistview/aeQuotation/airExport?parentOp=airExport';

  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  // sheetname max 31. 공통 부분은 짧게 줄임.
  title = title.replace('Accounting', 'Acct');
  title = title.replace('Ocean Import', 'OI');
  title = title.replace('Ocean Export', 'OE');
  title = title.replace('Air Import','AI');
  title = title.replace('Air Export','AE');
  title = title.replace('Other Shipment','Other Ship');
  title = title.replace('Warehousing', 'WH');
  title = title.replace('Customer List', 'Cust List');
  title = title.replace('Report (Manager)', 'Report');
  title = title.replace('Batch Recog History', 'Batch Recog');
  title = title.replace('Shipment Control Tower-Shipment Control Tower', 'Ship Control');
  title = title.replace('Shipment Control Tower-Report Scheduling', 'Scheduling');
  title = title.replace('Freight Receipt', 'F.Receipt');
  if (jobName === JobNames.AllContainer) title = title.replace('Container List', 'All');
  if (jobName === JobNames.Query || jobName === JobNames.CustomizedList) title = title.replace('OP Manager Report-', '');
  title = title.replace(/[\\\/\?\*\[\]\:]/g, '_');
  wb.SheetNames.push(title);

  const wsObjects = [];

  const table = document.getElementById(domId);
  const columnWidths = [];
  const backgroundRows =[];

  const listDataStorageKey = `ifms-list-data-${storageKeyMap.get(jobName)}`;
  let listData;

  if (jobName === 'SQUOT') {
    listData = fastStorage[oiQuotation] ?? fastStorage[oeQuotation];
  } else if (jobName === 'AQUOT') {
    listData = fastStorage[aiQuotation] ?? fastStorage[aeQuotation];
  } else if(jobName === 'JRNL'){
      if (domId.includes('acJournal-billings')) {
          listData = fastStorage[`ifms-list-data-${listurl}`];
      }
      else {
          listData = fastStorage[listDataStorageKey];
      }

  } else listData = fastStorage[listDataStorageKey];

  if(searchData && searchData.length > 0) listData = searchData;

  if (table && !!listData) {
    const rowHeaderColumns = table.querySelectorAll('div[id*="header"]');
    const generalRow = table.querySelectorAll('div[role="row"]');
    const firstRow = generalRow[1];
    const excelColType = listview.getExportRenderers(appcontext);
    const headerName = {};
    let statusColumnIndex = -1;

    if (listData && !!firstRow) {
      listData.forEach((r, ri) => {
        let rowObj = {};
        rowHeaderColumns.forEach((c, ci) => {
          if (ci === 0) return;
          if (ri === 0) {
            columnWidths.push(c.getBoundingClientRect().width);

            const headerKey = rowHeaderColumns[ci].dataset.columnId ?? '';
            if (headerKey === 'status') {
              statusColumnIndex = columnWidths.length - 1;
            }
          }
          
          const headerKey = rowHeaderColumns[ci].dataset.columnId ?? '';
          let header = rowHeaderColumns[ci].innerText ?? '';
          if (Object.keys(rowObj).some(key => key === header))
            header = header + 'Duptemp' + ci;
          let specialRenderer = excelColType.find((x) => x.accessor === headerKey)?.changedValue;
          let backColorRenderer = excelColType.find((x) => x.accessor === headerKey)?.backgroundColor;

          if (headerKey === 'status') {
            const statusValue = r[headerKey];
            rowObj[header] = statusValue === 'PC' ? 'Period Close' :
                             statusValue === 'OC' ? 'OP Close' :
                             statusValue === 'AC' ? 'Accounting Close' :
                             '';
          }
          else if(!!backColorRenderer && !!specialRenderer){
            rowObj[header] = specialRenderer(r);
            backgroundRows.push({color:backColorRenderer(r)}); //backgroundColor 넣기 위해 추가
          }
          else if (!!specialRenderer)
            rowObj[header] = specialRenderer(r);
          else if (!!backColorRenderer){
            rowObj[header] = r[headerKey];
            backgroundRows.push({color:backColorRenderer(r)}); //backgroundColor 넣기 위해 추가
          }
          else if (!!firstRow.querySelectorAll(`div[id*='${headerKey}-']`)) {
            const firstElemet = firstRow.querySelectorAll(`div[id*='${headerKey}-']`)[0];
            if (firstElemet === undefined)
              rowObj[header] = r[headerKey] ?? '';
            else if (firstElemet.className.includes('-check-box'))
              rowObj[header] = r[headerKey] ? 'checked' : '';
            else if (firstElemet.className.includes('datetime'))
              rowObj[header] = formatDateTime(r[headerKey]);
            else if (firstElemet.className.includes('date'))
              rowObj[header] = formatDate(r[headerKey]);
            else if (firstElemet.className.includes('float'))
              rowObj[header] = Decimalformat(r[headerKey], 2);
            else
              rowObj[header] = r[headerKey] ?? '';
          }
          else
            rowObj[header] = r[headerKey] ?? '';

          if (ri === 0) {
            headerName[header] = header.includes('Duptemp') ? header.substring(0, header.indexOf('Duptemp')) : (headerKey === 'trStatus2' ? 'T' : header);
          }
        });

        //Shipment Status List에서 Remark 컬럼이 없어도 excel 파일에는 Remark 컬럼을 추가 하라는 요청이 있어 따로 추가함 
        if (jobName === JobNames.RptCustomerShipment) {
          rowObj['remark'] = ''; 
        }

        if (ri === 0) {
          if (jobName === JobNames.RptCustomerShipment) {
            headerName['remark'] = 'Remark';
            columnWidths.push(200); 
          }
          wsObjects.push(headerName);
        }

        wsObjects.push(rowObj);
      });

      const ws = XLSX.utils.json_to_sheet(wsObjects,{skipHeader: true});

      // 헤더 행(row 0)을 제외하고 데이터 행에 셀 타입 적용
      const dataKeys = Object.keys(wsObjects[0]); // 헤더 키 목록
      for (let rowIdx = 1; rowIdx < wsObjects.length; rowIdx++) {        // row 0 = 헤더
        const rowData = wsObjects[rowIdx];
        dataKeys.forEach((key, colIdx) => {
          const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
          applyCellType(ws, cellAddress, rowData[key], key);
        });
      }

      //cell backgroundColor 추가
      if(wsObjects.length > 0 && backgroundRows.length > 0){
        for(let i =0; i < backgroundRows.length; i++){
          for(let c = 0; c < Object.keys(wsObjects[0]).length; c++){
            const cell = XLSX.utils.encode_cell({r:i+1,c: c});
            if(backgroundRows[i].color == 'none') continue;
            if (!ws[cell] || ws[cell].v == null) { //cell 값이 null이거나 undefined일때 backgroundColor가 칠해지지 않아서 추가
              ws[cell] = { v: '', t: 's' };
            }
            ws[cell].s = { ...(ws[cell].s || {}), fill: {fgColor: { rgb: backgroundRows[i].color }}}
          }
        }
      }


      //ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
      ws["!cols"] = columnWidths.map((x, index) => ({ wpx: index === statusColumnIndex ? 80 : x })); // status 컬럼의 width 늘리기 위해 추가함
      if (wsObjects.length > 0) {
        // Set up range under filter columns
        ws['!autofilter'] = { ref: `A1:${toColumnName(Object.keys(wsObjects[0]).length)}${wsObjects.length}` };
         //header column color 변경
        if(jobName === JobNames.RptCustomerShipment){
          for (let col = 1; col <= Object.keys(wsObjects[0]).length; col++) {
            const cell = toColumnName(col)+ '1';
            if (!ws[cell]) ws[cell] = {};  
            ws[cell].s = {
              font: {color: {rgb: "ffffff", bold: true}},
              fill: { fgColor: { rgb: 'D153C2' } }, 
            };
          }
        } 
      }
    
      wb.Sheets[title] = ws;
     
      const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
    
      XLSX.writeFile(wb, fileTitle, { compression: true});
    }
  }
}

export function exportCodeDataIntoExcel(data, title, columns) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    CreatedDate: new Date(),
  };

  title = title.replace(/[\\\/\?\*\[\]\:]/g, '_');
  wb.SheetNames.push(title);

  const wsObjects = [];
  const columnWidths = []; 
  if (data) {
    data.forEach((r, ri) => {
      const rowObj = {};
      columns.forEach((c, ci) => {
        if (ri === 0) {
          columnWidths.push(columns[ci].width);
        }
        const header = columns[ci].dataIndex;
        const headerKey = columns[ci].text;
        if (headerKey === 'Inactive')
          rowObj[headerKey] = (r[header] === true ? 'Checked' : '');
        else if(headerKey === 'Inactive Date')
          rowObj[headerKey] = formatDate(r[header]);
        else
          rowObj[headerKey] = r[header];
      });

      wsObjects.push(rowObj);
    });
  }
  const ws = XLSX.utils.json_to_sheet(wsObjects);

  ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
  if (wsObjects.length > 0) {
    // Set up range under filter columns
    ws['!autofilter'] = { ref: `A1:${toColumnName(Object.keys(wsObjects[0]).length)}${wsObjects.length}` };
  }

  wb.Sheets[title] = ws;


  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();

  XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function readExcel(data) {
  const workBook = XLSX.read(data);
  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], {header:["A","B","C","D","E"], defval : '' });


  // workBook.SheetNames.forEach(function (sheetName) {
  //   console.log('SheetName: ' + sheetName);
  //   let rows = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
  //   console.log(JSON.stringify(rows));
  // })
  return rows;
}

function ExcelCCReader(bankDate, checkNo, bankAmount) {
  this.bankDate = bankDate
  this.checkNo = checkNo
  this.bankAmount = bankAmount
}

function ExcelWHPReader(billCode, billDesc, rate, qty, isVat, whType, whRefID) {
  this.billCode = billCode
  this.billDesc = billDesc
  this.rate = rate
  this.qty = qty
  this.isVat = isVat
  this.whType = whType
  this.whRefID = whRefID
}

function ExcelJournalReader(glNo, comType, comId, desc, debit, credit) {
  this.glNo = glNo
  this.comType = comType
  this.comId = comId
  this.desc = desc
  this.debit = debit
  this.credit = credit
}

export function readClearExcel(data, startRow, heading, dateformat, neg) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});

  //heading = ["bankDate", "checkNo", "bankAmount","checkCondi","dateFormat","cehckCondiString"];

  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  rows.forEach(row => {
    if (!row[heading[0]] || !row[heading[1]] || ((!row[heading[3]])&& heading[5].length !== 0)) return;
    if (row[heading[0]] === '' || row[heading[1]] === '') return;
    if ( !isNaN(Number(row[heading[3]])) || !row[heading[3]].includes(heading[5])) return;
    if (!moment(row[heading[0]], dateformat).isValid()) return;
    if (isNaN(Number(row[heading[2]]))) return;
    // if (isNaN(Number(row[heading[3]]))) return;

    let bankDate = moment.utc(row[heading[0]]).format(dateformat);
    let checkNo = row[heading[1]].toString();
    checkNo = checkNo.replace(heading[5], "");
    checkNo = checkNo.replace("SUBSTITUTE CHECK", "");
    checkNo = checkNo.replace("CHECK", "");
    checkNo = checkNo.replace("Check #", "");
    checkNo = checkNo.replace("Check", "");
    checkNo = checkNo.replace(" ", "");

    let bankAmount = Number(row[heading[2]]);
    if (neg) bankAmount = -1 * bankAmount;

    list.push(new ExcelCCReader(bankDate, checkNo, bankAmount));
  });
  return list;
}

export function readJournalExcel(data) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});
  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  // Columns : Account Code, ComType, ComId, Description, Debit, Credit

  rows.forEach((row, i) => {
    if (i <= 0) return; // skip first row
    if (!row[0]) return;

    const glNo =  row[0];
    const comType = row[1];
    const comId = row[2];
    const desc = row[3];
    const debit = Number(row[4]);
    const credit = Number(row[5]);

    list.push(new ExcelJournalReader(glNo, comType, comId, desc, debit, credit));
  });
  return list;
}

export function readPeriodInvoiceExcel(data, heading) {
  const list = new Array();
  const workBook = XLSX.read(data, {type: "string"});

  const rows = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], { header: 1, defval: ''});

  rows.forEach(row => {
    if (!row[heading[0]] || !row[heading[2]] || !row[heading[6]] || !row[heading[7]] ) return;
    if (isNaN(Number(row[heading[2]] ?? 0)) || isNaN(Number(row[heading[3]] ?? 0)) || !isNaN(Number(row[heading[6]] ?? 0))) return;
    if (row[heading[0]] === '' || row[heading[2]] === '' || row[heading[6]] === '' || row[heading[7]] === '') return;
    if (!['whr','whs'].includes(row[heading[6]].toLowerCase())) return;
  

    let billCode = row[heading[0]];
    let billDesc = row[heading[1]];
    let rate =  Number(row[heading[2]]);
    let qty = Number(row[heading[3]]);
    let isVat = row[heading[5]];
    let whType = row[heading[6]];
    let whRefID = row[heading[7]];

    list.push(new ExcelWHPReader(billCode, billDesc, rate, qty, isVat, whType, whRefID));
  });
  return list;
}

export function taxReturnWithXLExport(title,tbId,userId,addData){
  const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: title,
      Subject: title,
      Author: userId,
      CreatedDate: new Date(),
    };
    wb.SheetNames.push(title);

    const wsObjects = [];
    const headerName =[];
    const table = document.getElementById(tbId);
    const columnWidths = [];

    if(table){
      if(addData){
        addData.forEach((a) => {
          wsObjects.push(a);
        })
      }
      const rows = table.querySelectorAll('div[role="row"]');
      rows.forEach((r, ri) => {
        if(r.id && r.id.includes('-header-row')) {
          return;
        }
        const rowObj = [];
        const columns = r.querySelectorAll('div[role="cell"]');
        columns.forEach((c, ci) => {
          if (ri === 1){
            columnWidths.push(c.getBoundingClientRect().width);
          }
          const header = table.querySelector(`#${c.id.substring(0, c.id.indexOf('-cell-'))}-header-${ci}`);
          const headerKey = header?.innerText ?? ``;
             
          if(headerKey !== 'Select' && headerKey !== 'No'){
            if (ri === 1){
              headerName.push(headerKey);
            }
            rowObj.push(c.innerText); 
          }
        });
        wsObjects.push(rowObj);
      });
      wsObjects.splice(addData.length,0,headerName);
    }
    const ws = XLSX.utils.aoa_to_sheet(wsObjects);

    // applyCellType 적용
    // addData 행(헤더 포함 이전 행) + headerName 행은 제외하고 데이터 행에만 적용
    // headerName이 삽입된 row index = addData.length
    const headerRowIndex = addData ? addData.length : 0;
    wsObjects.forEach((row, rowIdx) => {
      // addData 행 및 headerName 행은 스킵
      if (rowIdx <= headerRowIndex) return;
      if (!Array.isArray(row)) return;

      row.forEach((cellValue, colIdx) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
        applyCellType(ws, cellAddress, cellValue);
      });
    });

    ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
    wb.Sheets[title] = ws;

    const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
    XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function paymentToolWithXLExport(domId, title, userId, headerInfo, useBranch) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  wb.SheetNames.push(title);

  const wsObjects = [];
  const table = document.getElementById(domId);
  const columnWidths = [];
  const headerName =[];
  const headerName1 =[];
  const headerName2 =[];

  if (table) {
    // Type, Period 
    if (headerInfo) {
      headerInfo.forEach(x => {
        wsObjects.push(x);
      });
    }

    const rows = table.querySelectorAll('div[role="row"]');
    rows.forEach((r, ri) => {
      if (r.id && r.id.includes('-header-row')) {
        return;
      }
      const rowObj = [];
      let isSelect = false;
      let columnHorizontal = '';
      const columns = r.querySelectorAll('div[role="cell"]');
      columns.forEach((c, ci) => {
        const header = table.querySelector(`#${c.id.substring(0, c.id.indexOf('-cell-'))}-header-${ci}`);
        const headerKey = header?.innerText;

        if (headerKey !== '#') {
          if (ri === 1) {
            if (headerKey) {
              headerName.push(headerKey);
              columnWidths.push(c.getBoundingClientRect().width);
            }
          }

          if (headerKey) {
            if(c.innerHTML.includes('ifms-table-align-left')){
              columnHorizontal = 'left';
            }
            else if(c.innerHTML.includes('ifms-table-align-right')){
              columnHorizontal = 'right';
            }
            else {
              columnHorizontal = 'center';
            }
            rowObj.push({v:c.innerText, t:"s", s:{alignment: {horizontal: columnHorizontal}}});
          } else if (ci === (useBranch ? 23 : 22)) {  // 선택 된 항목만 출력
            if (c.getElementsByClassName('e-ifms-checkbox-icon-base e-ifms-checkbox').length > 0) isSelect = true;
          }
        }
      });

      if (isSelect) wsObjects.push(rowObj);
    });

    // Header Column Cell Merge : Header Column 이름이 변경 될 경우 수정 필요
    const firstColHeader = headerName.map(x => {
      if (x.includes("(Bill)")) return x.replace(" (Bill)", "");
      else if (x.includes("(Due)")) return x.replace(" (Due)", "");
      else if (["Bill Amount", "Due Amount", "Amount"].includes(x)) return "Total";
      else return x
    });
    const secondColHeader = headerName.map(x => {
      if (x.includes("(Bill)")) return "Bill";
      else if (x.includes("(Due)")) return "Due";
      else return x
    });

    firstColHeader.forEach((c) => {
      headerName1.push({v:c, t:"s", s:{font:{bold: true}, alignment: {horizontal: 'center', vertical: 'center'}, 
                      border:{top:{style:'medium', color:'black'},
                              right:{style:'medium', color:'black'},
                              bottom:{style:'medium', color:'black'},
                              left:{style:'medium', color:'black'}}}});
    });
    secondColHeader.forEach((c) => {
      headerName2.push({v:c, t:"s", s:{font:{bold: true}, alignment: {horizontal: 'center', vertical: 'center'}, 
                      border:{top:{style:'medium', color:'black'},
                              right:{style:'medium', color:'black'},
                              bottom:{style:'medium', color:'black'},
                              left:{style:'medium', color:'black'}}}});
    });

    wsObjects.splice(headerInfo.length, 0, headerName2);
    wsObjects.splice(headerInfo.length, 0, headerName1);
  }
  const ws = XLSX.utils.aoa_to_sheet(wsObjects);

  // applyCellType 적용
  // headerInfo 2행 + headerName1, headerName2 2행 = 총 (headerInfo.length + 2) 행까지 스킵
  const dataStartRowIndex = headerInfo.length + 2;
  wsObjects.forEach((row, rowIdx) => {
    if (rowIdx < dataStartRowIndex) return;  // headerInfo, headerName1, headerName2 행 스킵
    if (!Array.isArray(row)) return;

    row.forEach((cellObj, colIdx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });

      // applyCellType으로 타입 및 포맷 적용
      applyCellType(ws, cellAddress, cellObj.v);

      // applyCellType 적용 후 기존 alignment 스타일 병합
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          ...(ws[cellAddress].s ?? {}),
          alignment: { horizontal: cellObj.alignment },
        };
      }
    });
  });

  if (wsObjects.length > 0) {
    ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
    // Set up range under filter columns
    // ws['!autofilter'] = { ref: `A5:${toColumnName(Object.keys(wsObjects[headerInfo.length]).length)}${wsObjects.length}` };
    if (useBranch) {
      ws['!merges'] = [
        {s: { r:0, c:0 }, e: { r:0, c:17 }},    // Title
        {s: { r:3, c:0 }, e: { r:4, c:0 }},     // Date
        {s: { r:3, c:1 }, e: { r:4, c:1 }},     // BR 
        {s: { r:3, c:2 }, e: { r:4, c:2 }},     // Bill No  
        {s: { r:3, c:3 }, e: { r:4, c:3 }},     // Customer
        {s: { r:3, c:4 }, e: { r:4, c:4 }},     // Ref. No
        {s: { r:3, c:5 }, e: { r:4, c:5 }},     // B/L No
        {s: { r:3, c:6 }, e: { r:4, c:6 }},     // CUR
        {s: { r:3, c:7 }, e: { r:3, c:8 }},     // AR
        {s: { r:3, c:9 }, e: { r:3, c:10 }},    // AP
        {s: { r:3, c:11 }, e: { r:3, c:12 }},   // Duty AR
        {s: { r:3, c:13 }, e: { r:3, c:14 }},   // Duty AP
        {s: { r:3, c:15 }, e: { r:3, c:17 }},   // Total
      ]
    } else {
      ws['!merges'] = [
        {s: { r:0, c:0 }, e: { r:0, c:16 }},    // Title
        {s: { r:3, c:0 }, e: { r:4, c:0 }},     // Date
        {s: { r:3, c:1 }, e: { r:4, c:1 }},     // Bill No 
        {s: { r:3, c:2 }, e: { r:4, c:2 }},     // Customer  
        {s: { r:3, c:3 }, e: { r:4, c:3 }},     // Ref. No
        {s: { r:3, c:4 }, e: { r:4, c:4 }},     // B/L No
        {s: { r:3, c:5 }, e: { r:4, c:5 }},     // CUR
        {s: { r:3, c:6 }, e: { r:3, c:7 }},     // AR
        {s: { r:3, c:8 }, e: { r:3, c:9 }},     // AP
        {s: { r:3, c:10 }, e: { r:3, c:11 }},   // Duty AR
        {s: { r:3, c:12 }, e: { r:3, c:13 }},   // Duty AP
        {s: { r:3, c:14 }, e: { r:3, c:16 }},   // Total
      ]
    }
  }
  wb.Sheets[title] = ws;
 
  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
  XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function depositSlipWithXLExport(title, domId, userId, headerInfo, selectData) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };

  wb.SheetNames.push(title);

  const wsObjects = [];
  const headerName = [];
  const table = document.getElementById(domId);
  const columnWidths = [];

   if(headerInfo){
      headerInfo.forEach(x=>{
          wsObjects.push(x);
      });
   }
  const FIELD_MAP = {
    'Accrual Date': 'accrualDate',
    'Type': 'type',
    'Customer': 'customerName',
    'Received From': 'receivedFromName',
    'Check #': 'checkNo',
    'CUR': 'currency',
    'Items': 'items',
    'Amount': 'amount',
  };

  if (table && selectData && selectData.length > 0) {
    const rows = table.querySelectorAll('div[role="row"]');
    const headerRow = rows[0];
    const sampleRow = rows[1];

    if (headerRow && sampleRow) {
      const headerCells = headerRow.querySelectorAll('div[role="columnheader"]');
      const sampleCells = sampleRow.querySelectorAll('div[role="cell"]');
      const columnDefs = [];

      // '#' 컬럼
      headerName.push({
        v: '#', t: 's',
        s: { font: { bold: true }, alignment: { horizontal: 'center' },
             border: { top: {style:'medium',color:'black'}, right:{style:'medium',color:'black'}, bottom:{style:'medium',color:'black'}, left:{style:'medium',color:'black'} } },
      });
      columnWidths.push(40);

      headerCells.forEach((headerCell, ci) => {
        const headerText = (headerCell.innerText).replace(/[^\p{L}\p{N}#\s]/gu, '').replace(/\s+/g, ' ').trim();
        if (headerText === 'No' || headerText === 'Deposit') return;

        const field = FIELD_MAP[headerText];
        if (!field) return;
        columnWidths.push(headerCell.getBoundingClientRect().width); 

        const sampleCell = sampleCells[ci];
        let align = 'center';
        let format = 'text';
        if (sampleCell) {
          if (sampleCell.innerHTML.includes('ifms-table-align-left')) align = 'left';
          else if (sampleCell.innerHTML.includes('ifms-table-align-right')) align = 'right';

          if (sampleCell.innerHTML.includes('datetime')) format = 'datetime';
          else if (sampleCell.innerHTML.includes('date')) format = 'date';
          else if (sampleCell.innerHTML.includes('float')) format = 'number';
        }
        if (headerText === 'Check #') format = 'forceText';
        if (headerText === 'Amount') format = 'number'; 

        columnDefs.push({ headerText, field, align, format });

        headerName.push({
          v: headerText, t: 's',
          s: { font: { bold: true }, alignment: { horizontal: 'center' },
               border: { top: {style:'medium',color:'black'}, right:{style:'medium',color:'black'}, bottom:{style:'medium',color:'black'}, left:{style:'medium',color:'black'} } },
        });
      });

      wsObjects.push(headerName);

      selectData.forEach((record, idx) => {
        const rowObj = [
          { v: idx + 1, alignment: 'center', _isRowNumber: true },
          ...columnDefs.map(col => {
            const raw = record[col.field];
            if (col.format === 'date') {
              return { v: typeof raw === 'string' ? raw.slice(0, 10) : '', alignment: col.align };
            }
            if (col.format === 'number') {
              const amount = typeof raw === 'number' ? raw : parseFloat(String(raw ?? '').replace(/,/g, '')) || 0;
              return { v: amount, t: 'n', s: { alignment: { horizontal: col.align } }, z: '#,##0.00', _skip: true };
            }
            if (col.format === 'forceText') {
              return { v: String(raw ?? ''), alignment: col.align, _forceText: true };
            }
            return { v: raw ?? '', alignment: col.align };
          }),
        ];
        wsObjects.push(rowObj);
      });

      const amountColIndex = columnDefs.findIndex(c => c.headerText === 'Amount') + 1;
      let totalAmount = 0;
      selectData.forEach(record => {
        const raw = record.amount;
        totalAmount += typeof raw === 'number' ? raw : parseFloat(String(raw ?? '').replace(/,/g, '')) || 0;
      });

      const footerRow = [null, ...columnDefs.map((col, i) => {
        const idx = i + 1;
        if (idx === amountColIndex - 1) return { v: 'Total', t: 's', s: { font:{bold:true}, alignment:{horizontal:'right'} } };
        if (idx === amountColIndex) return { v: totalAmount, t: 'n', s: { font:{bold:true}, alignment:{horizontal:'right'} }, z:'#,##0.00', _skip:true };
        return null;
      })];
      wsObjects.push(footerRow);
    }
  }

  const ws = XLSX.utils.aoa_to_sheet(wsObjects);

  // applyCellType 적용
  // headerInfo 행 + headerName 행 이후부터 데이터 행 적용
  const dataStartRowIndex = headerInfo.length + 1;

  wsObjects.forEach((row, rowIdx) => {
    if (rowIdx < dataStartRowIndex) return;  // headerInfo, headerName 행 스킵
    if (!Array.isArray(row)) return;

    row.forEach((cellObj, colIdx) => {
      if (!cellObj) return;  // null 셀 스킵 (footer 빈 셀)

      const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });

      // skip 플래그가 있는 셀은 이미 타입/포맷이 명시된 셀이므로 스킵
      // (Amount 컬럼, footer Total/Amount 셀)
      if (cellObj._skip) {
        if (ws[cellAddress]) {
          // _skip 셀은 기존 t, z, s 그대로 worksheet에 반영
          ws[cellAddress].t = cellObj.t;
          ws[cellAddress].z = cellObj.z ?? ws[cellAddress].z;
          ws[cellAddress].s = cellObj.s ?? ws[cellAddress].s;
        }
        return;
      }

      // Check # 컬럼 applyCellType 스킵하고 강제 텍스트 포맷 지정
      if (cellObj._forceText) {
        if (ws[cellAddress]) {
          ws[cellAddress].v = cellObj.v;
          ws[cellAddress].t = 's';   // 문자열 타입
          ws[cellAddress].z = '@';   // 텍스트 포맷
          ws[cellAddress].s = {
            ...(ws[cellAddress].s ?? {}),
            alignment: { horizontal: cellObj.alignment },
          };
        }
        return;
      }

      // 일반 셀: applyCellType으로 타입/포맷 결정 후 alignment 병합
      applyCellType(ws, cellAddress, cellObj.v);
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          ...(ws[cellAddress].s ?? {}),
          alignment: { horizontal: cellObj.alignment },
        };
      }
    });
  });

  ws["!cols"] = columnWidths.map(x => ({ wpx: x }));
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } },    // Title
  ]
  wb.Sheets[title] = ws;
  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
  XLSX.writeFile(wb, fileTitle, { compression: true });
}

export function salesCostBatchRecogWithXLExport(title, tbId, userId, addData, listData) {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Subject: title,
    Author: userId,
    CreatedDate: new Date(),
  };
  wb.SheetNames.push(title);

  const wsObjects = [];
  const headerName = [];
  const table = document.getElementById(tbId);
  const rowHeaderColumns = table.querySelectorAll('div[id*="header"]');
  const generalRow = table.querySelectorAll('div[role="row"]');
  const firstRow = generalRow[1];
  let columnWidths = [];

  let closedColumnIndex = -1;
  
  rowHeaderColumns.forEach((c, ci) => {
    if (ci === 0) return;
    
    columnWidths.push(c.getBoundingClientRect().width);
    
    let header = c.innerText ?? '';
    const headerKey = c.dataset.columnId ?? '';

    if (headerKey !== 'action' && headerKey !== 'scroll') {
      if (headerName.includes(header)) {
        header = header + 'Duptemp' + ci;
      }
      
      headerName.push(
        header.includes('Duptemp') 
          ? header.substring(0, header.indexOf('Duptemp'))
          : (headerKey === 'trStatus2' ? 'T' : header)
      );

      if (headerKey === 'closed') {
        closedColumnIndex = headerName.length - 1;
      }
    }
  });

  // + 컬럼에서 Period Close 데이터가 있으면 너비 2배로 늘리기
  if (closedColumnIndex !== -1 && listData.some(r => r['closed'] === 2)) {
    columnWidths[closedColumnIndex] *= 2;
  }

  if (addData && addData.length > 0) {
    addData.forEach((data, index) => {
      if (index === 0) {
        wsObjects.push(data);
      } else {
        // 두 번째 데이터부터 첫 번째 값은 A열, 두 번째 값은 D열에 위치
        let row = [];
        row[0] = data[0];
        row[3] = data[1];
        wsObjects.push(row);
      }
    });
  }

  wsObjects.push(headerName);

  if (listData && !!firstRow) {
    listData.forEach((r, rIndex) => {
      let rowObj = [];

      rowHeaderColumns.forEach((c, ci) => {
        if (ci === 0) return; 
        
        const headerKey = c.dataset.columnId ?? '';

        if (headerKey !== 'action' && headerKey !== 'scroll') {
          if (!!firstRow.querySelectorAll(`div[id*='${headerKey}-']`)) {
            const firstElement = firstRow.querySelectorAll(`div[id*='${headerKey}-']`)[0];

            if (firstElement === undefined) {
              if (headerKey === 'indicator') {
                rowObj.push((rIndex + 1) ?? '');
              } else if(headerKey === 'recogDate' || headerKey === 'firstDate') {
                rowObj.push(moment(r[headerKey]).format('YYYY-MM-DD'));
              } else if (headerKey === 'closed') {
                rowObj.push(r[headerKey] === 2 ? 'Period Close' : '');
              } else if(headerKey === 'selected') {
                rowObj.push(String(r[headerKey]).toLowerCase() === 'true' || r[headerKey] === 1 ? 1 : 0);
              } else {
                rowObj.push(r[headerKey] ?? '');
              }
            }
            else if (firstElement.className.includes('datetime'))
              rowObj.push(formatDateTime(r[headerKey]));
            else if (firstElement.className.includes('date'))
              rowObj.push(formatDate(r[headerKey]));
            else if (firstElement.className.includes('float'))
              rowObj.push(Decimalformat(r[headerKey], 2));
            else
              rowObj.push(r[headerKey] ?? '');
          }
          else {
            rowObj.push(r[headerKey] ?? '');
          }
        }
      });

      wsObjects.push(rowObj);
    });
  }

  const ws = XLSX.utils.aoa_to_sheet(wsObjects);

  // applyCellType 적용
  // addData 행들 + headerName 행 이후부터 데이터 행으로 판별
  // addData가 없을 경우 headerName만 1행 존재
  const addDataLength = (addData && addData.length > 0) ? addData.length : 0;
  const dataStartRowIndex = addDataLength + 1; // addData 행들 + headerName 행(1행)

  wsObjects.forEach((row, rowIdx) => {
    if (rowIdx < dataStartRowIndex) return; // addData 행 및 headerName 행 스킵
    if (!Array.isArray(row)) return;

    row.forEach((cellValue, colIdx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
      applyCellType(ws, cellAddress, cellValue);
    });
  });

  ws["!cols"] = columnWidths.map(x => ({ wpx: x }));

  if (wsObjects.length > 0) {
    ws['!autofilter'] = { ref: `A5:${toColumnName(headerName.length)}${wsObjects.length}` };
  }

  wb.Sheets[title] = ws;
   
  const fileTitle = `${title}-${formatDateTime(now())}.xlsx`.replaceAll(' ', '-').toLowerCase();
  XLSX.writeFile(wb, fileTitle, { compression: true });
}


/**
 * 셀 값에 따라 XLSX 셀 타입 및 포맷을 지정
 * @param {object} ws - XLSX worksheet 객체
 * @param {string} cellAddress - 셀 주소 (ex. "A1")
 * @param {any} value - 셀에 입력할 값
 */
function applyCellType(ws, cellAddress, value, headerKey) {
  const input = value === null || value === undefined ? '' : String(value);

  const numericCheck = input.replace(/,/g, '').trim();

  if (!ws[cellAddress]) {
    ws[cellAddress] = {};
  }

  const cell = ws[cellAddress];
  const textColumns = [
    'Invoice #', 'Bill #', 'Check #',
    'MBL #', 'MBL', 'MAWB #', 'MAWB', 'HBL #', 'HBL', 'HAWB #', 'HAWB', 'MBL / MAWB', 'HBL / HAWB', 'Booking #',
    'Ref. #'
  ];
  
  // 특정 컬럼들은 값이 숫자여도 텍스트로 설정
  if (textColumns.includes(headerKey)) {
    cell.v = input;
    cell.t = 's';
    cell.z = '@';
  }
  // 0으로 시작하는 숫자 문자열 (ex. 012345) → 텍스트 포맷
  else if (/^0\d+$/.test(input)) {
    cell.v = input;
    cell.t = 's';       // string type
    cell.z = '@';       // 텍스트 포맷
  }
  // 날짜 형식 파싱
  else if (tryParseDate(input) !== null) {
    const dateValue = tryParseDate(input);
    const excelDate = dateToExcelSerial(dateValue);
    cell.v = excelDate;
    cell.t = 'n';                 // number type (XLSX에서 날짜는 숫자로 저장)
    cell.z = 'yyyy-mm-dd';        // 날짜 포맷
  }
  // 숫자 파싱
  //else if (input !== '' && !isNaN(Number(input.replace(/,/g, '')))) {
  else if(input !== '' && numericCheck !== '' && !isNaN(numericCheck)){
      const numberValue = Number(numericCheck);
      const decimalPlaces = numericCheck.includes('.')
      ? input.split('.')[1].length
      : 0;
    const format =
      decimalPlaces <= 0
        ? '#,##0'
        : '#,##0.' + '0'.repeat(decimalPlaces);

    cell.v = numberValue;
    cell.t = 'n';       // number type
    cell.z = format;    // 숫자 포맷
  }
  // 빈 값 → General 포맷
  else if (input === '') {
    cell.v = '';
    cell.t = 's';
    cell.z = 'General';
  }
  // 그 외 문자열 → 텍스트 포맷
  else {
    cell.v = input;
    cell.t = 's';
    cell.z = '@';
  }
}

/**
 * 날짜 문자열 파싱
 * 지원 포맷: yyyy/MM/dd, MM/dd/yyyy, dd/MM/yyyy, yyyy-MM-dd, MM-dd-yyyy, dd-MM-yyyy
 * @param {string} input
 * @returns {Date|null}
 */
function tryParseDate(input) {
  if (!input || input.trim() === '') return null;

  const formats = [
    // yyyy/MM/dd or yyyy-MM-dd
    { regex: /^(\d{4})[\/\-](\d{2})[\/\-](\d{2})$/, y: 1, m: 2, d: 3 },
    // MM/dd/yyyy or MM-dd-yyyy
    { regex: /^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/, y: 3, m: 1, d: 2 },
    // dd/MM/yyyy or dd-MM-yyyy (MM/dd와 구분 불가 시 yyyy 위치로 판별)
    // 위 regex와 동일하나 m/d 순서 반전 - 필요 시 별도 플래그로 구분 가능
  ];

  for (const fmt of formats) {
    const match = input.match(fmt.regex);
    if (match) {
      const year  = parseInt(match[fmt.y], 10);
      const month = parseInt(match[fmt.m], 10) - 1; // JS month는 0-indexed
      const day   = parseInt(match[fmt.d], 10);
      const date  = new Date(year, month, day);

      // 유효한 날짜인지 검증
      if (
        date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day
      ) {
        return date;
      }
    }
  }

  return null;
}

/**
 * JS Date → Excel Serial Number 변환
 * Excel은 1900-01-01을 1로 기산
 * @param {Date} date
 * @returns {number}
 */
function dateToExcelSerial(date) {
  const EXCEL_EPOCH = Date.UTC(1899, 11, 30); // 1899-12-30
  const dateUtcMs = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.floor((dateUtcMs - EXCEL_EPOCH) / msPerDay);
}